/**
 * Einen Namen an Ort und Stelle ändern: aus dem Text wird ein Feld.
 * Enter oder Wegklicken übernimmt, Esc lässt alles, wie es war.
 */
export function umbenennen(ziel, { wert, beschriftung, onFertig }) {
  const feld = document.createElement('input');
  feld.type = 'text';
  feld.className = 'umbenennen';
  feld.value = wert;
  feld.setAttribute('aria-label', beschriftung);
  ziel.replaceWith(feld);
  feld.focus();
  feld.select();

  let erledigt = false;
  const ende = (neu) => {
    if (erledigt) return;
    erledigt = true;
    onFertig(neu);
  };
  feld.addEventListener('keydown', (e) => {
    // Die Taste gehört dem Feld und nicht der Zeile oder der Spalte dahinter.
    e.stopPropagation();
    if (e.key === 'Enter') { e.preventDefault(); ende(feld.value.trim() || wert); }
    if (e.key === 'Escape') ende(wert);
  });
  feld.addEventListener('click', (e) => e.stopPropagation());
  feld.addEventListener('blur', () => ende(feld.value.trim() || wert));
}
